export function getInitialState(orgId: string) {
  // I am assuming this is mutex from organization unmounts
  return orgId.length > 0 ? 'idle-revisit' : 'idle';
}
